export const arcReceipt = {
    type: "none",
    itemId: "receipt",
    rules: {
        section: {
            "thankYouMessage.label": {
                all: [
                    { compare: ["#section", "==", "receipt"] },
                    { any: [
                        { compare: ["#transactionNumber.value", "!"] },
                        { compare: ["#paymentErrorHack", "!!"] }
                    ]}
                ],
                equal: "<h1>Thank you for your submission.</h1><div class='bg-255 c-0 pad-12'>We are having trouble processing your payment at this time. A representative will reach out to you.</div>",
                fallback: "<h1>Thank you for your payment.</h1>"
            },
            "transactionConfirmation.visible": {
                all: [
                    { compare: ["#transactionNumber.value", "!!"] },
                    { compare: ["#paymentErrorHack", "!"] }
                ]
            },
            "receiptConfirmation.visible": {
                all: [
                    { compare: ["#transactionNumber.value", "!!"] },
                    { compare: ["#paymentErrorHack", "!"] }
                ]
            },
        },
        paymentErrorHack: {
            "thankYouMessage.visible": { compare: ["#paymentErrorHack", "!"] },
            "paymentErrorMessage.visible": { compare: ["#paymentErrorHack", "!!"] }
        }
    },
    items: [
        // "Thank You" Message
        {
            type: "none",
            itemId: "thankYouMessage",
            className: "container c-0-65-92",
            label: `<h1>Thank you for your payment.</h1>`
        },
        // "Payment Error" Message
        {
            type: "none",
            itemId: "paymentErrorMessage",
            className: "container c-0-65-92",
            label: "<h1>Thank you for your submission.</h1><div class='bg-255 c-0 pad-12'>We're having trouble processing your payment at this time. A representative will reach out to you.",
        },
        // Transaction Confirmation
        {
            type: "none",
            itemId: "transactionConfirmation",
            items: [
                {
                    type: "text",
                    itemId: "transactionNumber",
                    label: "Payment Transaction Number:",
                    className: "container",
                    disabled: true
                },
                {
                    type: "text",
                    itemId: "confirmationNumber",
                    label: "Payment Confirmation Number:",
                    className: "container",
                    disabled: true
                },
                {
                    type: "text",
                    itemId: "paymentMessage",
                    label: "Payment Message:",
                    className: "container",
                    disabled: true
                }
            ]
        },
        // Receipt Confirmation
        {
            type: "none",
            itemId: "receiptConfirmation",
            className: "container",
            items: [
                {
                    type: "none",
                    label: "A record of this transaction has been sent to:",
                    className: "col-md-6"
                },
                {
                    type: "text",
                    itemId: "receiptEmail",
                    className: "col-md-6",
                    disabled: true
                }
            ]
        },
        // Receipt Summary
        {
            type: "none",
            itemId: "receiptSummary",
            items: []
        }
    ]
};
